import Agilite from 'agilite'
import CoreEnums from '../../../../core/utils/enums'
import store from '../../../../store'
import EntityEnums from './enums'
import ConfigEnums from '../../config/utils/enums'
import { getDataWithSync } from '../../../../db/dbSync'
import { STORES } from '../../../../db/indexedDB'

const agilite = new Agilite({
  apiServerUrl: process.env.REACT_APP_AGILITE_API_URL,
  apiKey: process.env.REACT_APP_AGILITE_API_KEY
})

export const readEntities = (filters, projection) => {
  return new Promise((resolve, reject) => {
    let qry = {}
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        // Only process filters if they exist
        if (filters && typeof filters === 'object') {
          // Use Object.entries for more efficient iteration
          Object.entries(filters).forEach(([key, value]) => {
            if (value !== '' && value !== undefined && value !== null) {
              qry[key] = value
            }
          })
        }

        response = await agilite.Connectors.execute(EntityEnums.profileKeys.ENTITIES, EntityEnums.routeKeys.READ, {
          filter: JSON.stringify(qry),
          page: null,
          pageLimit: null
        })
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const readEntitiesPwa = (filters = {}, projection = '') => {
  return new Promise((resolve, reject) => {
    ;(async () => {
      let qry = {}
      let errorMessage = null

      try {
        // Only process filters if they exist
        if (filters && typeof filters === 'object') {
          // Use Object.entries for more efficient iteration
          Object.entries(filters).forEach(([key, value]) => {
            if (value !== '' && value !== undefined && value !== null) {
              qry[key] = value
            }
          })
        }

        const entities = await getDataWithSync(STORES.ENTITIES, {
          body: {
            filter: JSON.stringify(qry),
            page: null,
            pageLimit: null,
            projection
          },
          requestConfig: {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'profile-key': EntityEnums.profileKeys.ENTITIES,
              'route-key': EntityEnums.routeKeys.READ
            }
          }
        })
        resolve(entities)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const createEntity = (data) => {
  return new Promise((resolve, reject) => {
    let entityResponse = null
    let errorMessage = null
    let timestamp = Date()

    ;(async () => {
      try {
        data.dateCreated = timestamp
        data.dateModified = timestamp
        data.createdBy = store.getState().auth.agiliteUser._id
        data.modifiedBy = store.getState().auth.agiliteUser._id

        entityResponse = await agilite.Connectors.execute(
          EntityEnums.profileKeys.ENTITIES,
          EntityEnums.routeKeys.CREATE,
          {
            data: JSON.stringify(data)
          }
        )

        await agilite.Connectors.execute(ConfigEnums.profileKeys.CONFIG, ConfigEnums.routeKeys.UPDATE, {
          filter: JSON.stringify({ entityRef: entityResponse.data._id }),
          data: JSON.stringify({ entityRef: entityResponse.data._id })
        })

        resolve(entityResponse.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const updateEntity = (data) => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null
    let timestamp = Date()

    ;(async () => {
      try {
        data.dateModified = timestamp
        data.modifiedBy = store.getState().auth.agiliteUser._id

        response = await agilite.Connectors.execute(EntityEnums.profileKeys.ENTITIES, EntityEnums.routeKeys.UPDATE, {
          recordId: data._id,
          data: JSON.stringify(data)
        })

        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const readPaymentMethods = () => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        response = await agilite.Keywords.getValuesByProfileKey(EntityEnums.profileKeys.PAYMENT_METHODS)
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}

export const readProcedures = () => {
  return new Promise((resolve, reject) => {
    let response = null
    let errorMessage = null

    ;(async () => {
      try {
        response = await agilite.Keywords.getValuesByProfileKey(EntityEnums.profileKeys.PROCEDURES)
        resolve(response.data)
      } catch (e) {
        if (e.response?.data?.errorMessage) {
          errorMessage = e.response.data.errorMessage
        } else if (e.message) {
          errorMessage = e.message
        } else {
          errorMessage = CoreEnums.errorMessages.UNKNOWN_ERROR
        }

        reject(errorMessage)
      }
    })()
  })
}
